module.exports = __webpack_public_path__ + "static/img/peopleGame.3c2395c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/hotGame/peopleGame.png
// module id = Rlus
// module chunks = 3